/* eslint-disable prettier/prettier */
// Home
export const PATH_HOME = '/'

// Nominate password
export const PATH_REGISTER = '/paytrack-register'
export const PATH_REGISTER_EXISTED = '/paytrack-register/existed'

// Auth
export const PATH_LOGIN = '/auth/login'

// Password
export const PATH_WHITELIST_PASSWORD_RESET = '/password/whitelist-reset'
export const PATH_FORGOT_PASSWORD = '/password/forgot'
export const PATH_RESET_PASSWORD = '/password/reset'
export const PATH_FORGOT_PASSWORD_SUCCESS = '/password/forgot-success'

// Dashboard
export const PATH_MY_ACCOUNT = '/account'

// Profile
export const PATH_PROFILE = '/account/profile/:lessorName/:companyId/:vendorId'

// Announcememt
export const PATH_ANNOUNCEMENT_VIEW = '/account/announcement/:announcementId'

// Payment
export const PATH_PAYMENT_CONTRACT = '/account/contract/:contractNumber/:vendorCode/:companyCode'
export const PATH_PAYMENT_VIEW = '/account/payment/:paymentId/:paymentMethod/:vendorCode/:companyCode/:contractNumber'

// Ecwt
export const PATH_ECWT_LIST = '/ecwts'
export const PATH_ECWT_VIEW = '/ecwts/:id'

// Hs
export const PATH_TICKET_SUPPORT = '/support'
export const PATH_TICKET_LIST_CLOSED = '/support/ticket/closed'
export const PATH_TICKET_VIEW = '/support/ticket/view/:id'

// Errors
export const PATH_EXPIRED = '/expired'
export const PATH_NOT_FOUND = '/*'
